import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface Breadcrumb {
  label: string;
  path?: string;
}

@Injectable({
  providedIn: "root",
})
export class TitleService {
  private _titleSubject = new BehaviorSubject<string>("Dashboard");
  title$ = this._titleSubject.asObservable();

  private _breadcrumbsSubject = new BehaviorSubject<Breadcrumb[] | null>(null);
  breadcrumbs$ = this._breadcrumbsSubject.asObservable();

  constructor() {}

  setTitle(title: string) {
    this._titleSubject.next(title);
    this._breadcrumbsSubject.next(null); // resetea los breadcrumbs si se usa solo título
  }

  setBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    this._breadcrumbsSubject.next(breadcrumbs);
  }
}
